import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面未找到 - po18娱乐内容聚合平台",
    description: "抱歉，你访问的页面不存在。返回 po18 首页继续浏览最新娱乐资讯与影视推荐。",
    keywords: "po18,404,页面未找到",
  });

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 py-20 md:py-28 text-center">
        <p className="text-7xl md:text-9xl font-black text-primary-100 select-none">
          404
        </p>
        <h1 className="mt-4 text-2xl md:text-3xl font-black text-foreground-950">
          抱歉，页面走丢了
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500">
          你访问的页面可能已被移除或暂时不可用，不妨回到首页继续逛逛。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-line text-lg" />
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-900 text-sm font-semibold hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-film-line text-lg" />
            浏览电影
          </Link>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-900 text-sm font-semibold hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-newspaper-line text-lg" />
            娱乐资讯
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}